var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.brand.isFindmate)?_c('b-alert',{staticClass:"mt-2",attrs:{"variant":"primary","show":""}},[_c('font-awesome-icon',{attrs:{"icon":"fa-duotone fa-info-circle"}}),_vm._v(" "+_vm._s(_vm.$t("Charges on your card will show as:"))+" "),_c('span',{staticClass:"font-weight-bold text-success"},[_vm._v("FINDMATE, LLC")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }